import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/features/auth/AuthProvider';
import { AdminLoginPage } from '@/pages/auth/AdminLoginPage';

/** Accès /admin : login staff dédié si non authentifié, shell si staff. */
export function AdminAuthGate() {
  const { session, profile, loading, profileLoading, isStaff } = useAuth();

  if (loading || (session && profileLoading && !profile)) {
    return <div className="shell-boot" aria-busy="true" aria-label="Chargement" />;
  }

  if (!session) {
    return <AdminLoginPage />;
  }

  if (profile && !profile.is_active) {
    return (
      <div className="page-center">
        <h1>Compte désactivé</h1>
        <p>Contactez l’équipe ISBD pour réactiver votre accès.</p>
      </div>
    );
  }

  if (!isStaff) {
    return <Navigate to="/app" replace />;
  }

  return <Outlet />;
}
